<!--
 * @Author: DLLCNX dllcnx@foxmail.com
 * @Date: 2023-12-26 09:56:15
 * @LastEditors: DLLCNX dllcnx@foxmail.com
 * @LastEditTime: 2024-01-02 12:56:43
 * @FilePath: /smartEarthDemo/src/demo/scene/mapbox.vue
 * @Description: 
-->
<template>
<div style="height:100%">
  <div id="csContainer">
  </div>
  <div id="loadingOverlay"><h1>Loading........</h1></div>
</div>
</template>


<script>
    /*eslint-disable*/
    import * as Cesium from "cesium/Cesium";
    import widgets from "cesium/Widgets/widgets.css";
    import util from "../../components/util"
    export default {
        name: 'headMap',
        data(){
            return{
            }
        },
        mounted(){
          var loa=document.getElementById('loadingOverlay');
        setTimeout(()=>{
           loa.style.display="none";
       },4000);
            this.init();
        },
        methods:{
            init(){
              let viewer = util.getViewer("csContainer", {
                    // imageryProvider :new Cesium.MapboxImageryProvider({
                    //     mapId: 'mapbox.dark',
                    //     accessToken:"pk.eyJ1IjoicmFuZ28xMjM0NTY3OCIsImEiOiJja2U5YzFwem4xdjh1MnJsNjdsZTdtdjd6In0.S-m8w-Tl_Zy68PEtwgIdgA"
                    // }),
                imageryProvider : new Cesium.UrlTemplateImageryProvider({
                  // url: "http://webrd02.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}",
                  url: qexc.tiles.lanhei,
                  layers: 'earth'
                }),
                    baseLayerPicker: false
                });
              // debugger
              this.viewer = viewer;

              let  cf = new Cesium.Cartesian3(-4107046.6468334734, 15755722.58519879, 12073099.956117895)  ;

              this.viewer.camera.setView({
                destination :cf,
                orientation : {
                  heading : 6.21390483292924,
                  pitch : -1.5664340610879344,
                  roll : 0.0
                }
              });
            },

        }
    }
</script>
<style scoped>
  .headMap {
    position: absolute;
    margin-left: 20px;
    margin-top:10px;
    z-index: 999;
  }
  #heatmap{
    width: 500px;
    height: 500px;
  }
  #csContainer {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
</style>
